import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";

import * as passwordAction from "../../actions/passwordActions";
import { errorToast } from "../../components/Toast";

/**
 * Komponent zawierający formularz do zmiany hasła.
 * 
 * Na wstępie walidujemy token zawarty w URL, i jeśli jest nieważny/nieprawidłowy - następuje przekierowanie na główną stronę, z informacją o wygaśnięciu tokena.
 * 
 * Po zatwierdzeniu akcji - następuje przekierowanie na główną stronę, z informacją o zmianie hasła.
 * 
 */
class ResetPassword extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            newPassword: "",
            confirmPassword: "",
        };

    }

    componentDidMount() {

        //walidacja tokena
        this.props.onFetch(this.props.match.params.token);
    }

    handleSubmit = e => {
        e.preventDefault();
        let valid = this.handlePasswordMatch();
        if (valid) {
            this.props.onResetPassword({ resetPasswordToken: this.props.match.params.token, password: this.state.newPassword });
        } else {
            errorToast({ message: "Pola 'Nowe hasło' i 'Potwierdź hasło' muszą być identyczne" });
        }
    };

    handlePasswordMatch = () => {
        if (this.state.newPassword === this.state.confirmPassword) {
            return true;
        }
        return false;
    }

    handleNewPasswordChange = e => {
        const target = e.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        this.setState({ newPassword: value });
    };

    handleConfirmPasswordChange = e => {
        const target = e.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        this.setState({ confirmPassword: value });
    };

    render() {

        return (

            <div className="w3-display-container" style={{ height: "100vh" }}>

                <div className="w3-display-middle">

                    <div className="w3-container">

                        <div className="w3-card-4" style={{ width: "40vw" }}>

                            <div className="w3-container w3-theme-dark w3-center">
                                <h2><FormattedMessage
                                    id="app.resetPasswordPage.title"
                                    defaultMessage="Forgot password"
                                /></h2>
                            </div>

                            <div className="w3-container">

                                <p>
                                    <FormattedMessage
                                        id="app.resetPasswordPage.description"
                                        defaultMessage="Enter the email address associated with your account and we'll send you a password change link."
                                    />
                                </p>

                                <form
                                    className="w3-container w3-padding"
                                    onSubmit={this.handleSubmit}
                                >
                                    <div className="w3-row-padding">
                                        <input
                                            className="w3-input"
                                            type="password"
                                            name="newPassword"
                                            onChange={this.handleNewPasswordChange}
                                            value={this.state.newPassword}
                                            required
                                        />
                                        <label className="w3-text-theme w3-small">
                                            <FormattedMessage id="user.newPassword" defaultMessage="New Password" />
                                        </label>
                                    </div>

                                    <div className="w3-row-padding">
                                        <input
                                            className="w3-input"
                                            type="password"
                                            name="confirmPassword"
                                            onChange={this.handleConfirmPasswordChange}
                                            value={this.state.confirmPassword}
                                            required
                                        />
                                        <label className="w3-text-theme w3-small">
                                            <FormattedMessage id="user.confirmPassword" defaultMessage="Confirm Password" />
                                        </label>
                                    </div>

                                    <div className="w3-bar">
                                        <button
                                            className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
                                            type="submit"
                                        >
                                            <FormattedMessage
                                                id="app.resetPasswordPage.action.submit"
                                                defaultMessage="Send"
                                            />
                                        </button>
                                    </div>
                                </form>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        )

    }

}

const mapStateToProps = state => {
    return {

    };
};

const mapDispatchToProps = dispatch => {
    return {
        onResetPassword: (user, callback) => {
            dispatch(passwordAction.doResetPassword(user, callback));
        },
        onFetch: (token, callback) => {
            dispatch(passwordAction.doFetchToken(token, callback));
        }
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ResetPassword);